export const formatDateToIsoStandard = (date) => {
    const d = new Date(date);
    // Format date to yyyy-mm-dd
    return d.toISOString().split('T')[0];
}